// bao migrate skip
import "./../factories/search-paging";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabPage from "./../factories/tab-page";
import BaoMenu from "./../services/bao-menu";
import BaoRouter from "./../services/bao-router";
import BaoDialogViewModel from "./../factories/bao-dialog";
import SearchPaging from "./../factories/search-paging";
import { TicketTypeCategoriesConstants } from "./constants/ticket-type-categories-constants"

class HolidayViewModel extends (SearchPaging as any) {


        TicketStateIdApproved = ko.observable();
        TicketStateIdDeclined = ko.observable();
        TicketStateIdInDecision = ko.observable();
        TicketStatusClosed = ko.observable();
        TicketStatusWaitsForApproval = ko.observable();


    /**
     * constructor
     */
    constructor(tabPage) {
        super(tabPage);
        this.AlertCss = ko.computed(() => {
            if (this.TicketApproveStateId() == this.TicketStateIdApproved()) {
                return "alert-success";
            }
            else if (this.TicketApproveStateId() == this.TicketStateIdDeclined()) {
                return "alert-danger";
            }
            return "alert-info";
        });

        /**
         * Subscribe for Ticket or Holidaytype
         */
        this.TicketTypeId.subscribe(() => {
            this.GetTicketTypeCategory();
            if (this.initInProgess == false) {
                this.IsApprovalAllowed();
            }
        });

        /**
         * Subscribe for Days
         */
        this.HolidayDaysDropdown.subscribe((item) => {
            if (this.initInProgess == false && this.HolidayTypeAsString() == "1") {
                if (item != undefined) {
                    this.HolidayDaysJs(item);
                }
            }
        });

        this.subscribe(this.ApprovalAllowed, (newValue) => {
            if (newValue != null) {
                BaoMenu.permissionEnable({
                    ActionKey: "ActionHolidayApprove",
                    Enabled: !this.IsReadonly() && this.ApprovalAllowed() && (this.TicketApproveStateId() == null || this.TicketApproveStateId() == this.TicketStateIdInDecision()),
                    Context: this.TabPage.Context()
                });
            }
        });

        this.HolidayDaysJs.subscribe((item) => {
            this.HolidayDaysDropdown(item);
        });

        this.HolidayTypeAsString.subscribe((newval) => {
            if (this.initInProgess == false) {
                //this.FromDateJs();
                this.ToDateJs("");
                if (newval === "0") { // when the field needs to be calculated
                    this.HolidayDays(null);
                    this.HolidayDaysJs(null);
                }
                else {
                    this.HolidayDays(1);
                    this.HolidayDaysJs(1);
                    this.HolidayDaysDropdown("1");
                }
            }
        });

        this.FromDateJs.subscribe(() => {
            this.CalculateHolidayDays();
        });

        this.ToDateJs.subscribe((ite) => {
            if (this.ignoreSubscribes) {
                return;
            }
            this.CalculateHolidayDays();
        });


        /*
         * Menu Event - Click
         */
        this.TabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case "ActionHolidayApprove":
                        this.Approve();
                        break;
                    case "ActionHolidayReOpen":
                        this.ReopenHoliday();
                        break;
                }
            }
        }));
    }

    Bao = Bao;
    initInProgess = true;
    ignoreSubscribes = false;
    AlertCss: KnockoutComputed<string>;

    _deleteMessage = Bao.Session.GetMessage("msgDeleteTicket");
    _saveMessage = Bao.Session.GetMessage("msgSaveCheck");
    _msgYes = Bao.Session.GetMessage("msgYes");
    _msgNo = Bao.Session.GetMessage("msgNo");
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");

    TicketTypes = ko.observableArray([]);
    Solution = ko.observable();
    Problem = ko.observable();

    ApprovalRequired = ko.observable();
    AffectedPersonSupervisor = ko.observable();
    TicketTypeName = ko.observable();
    AffectedPersonId = ko.observable();
    OwnerPersonName = ko.observable();
    AffectedPersonName = ko.observable();
    AffectedPersonStateName = ko.observable();
    HolidayDays = ko.observable();
    HolidayDaysDropdown = ko.observable("1");
    IsSubstituteClarified = ko.observable();
    HolidayTypeAsString = ko.observable();
    IsPersonalDepartmentSuperior = ko.observable<boolean>(true);
    TicketTypeId = ko.observable();
    HolidayHideIsSubstituteClarified = ko.observable(false);
    FromDateJs = ko.observable();
    ToDateJs = ko.observable();
    TicketApproveStateId = ko.observable();
    TicketLocked = ko.observable(false);
    IsReadonly = ko.observable(false);
    HolidayDaysJs = ko.observable<any>();
    initialPersonId = null;
    initialDate = null;
    prefill = null;

    OwnerPersonId: KnockoutObservable<string>;
    ToDate: KnockoutObservable<string>;
    FromDate: KnockoutObservable<string>;
    TicketId: KnockoutObservable<string>;
    SaveAllowed: KnockoutObservable<boolean>;
    LockGuid: KnockoutObservable<string>;
    TicketStatusId: KnockoutObservable<string>;
    ApprovalAllowed = ko.observable();

    AffectedPersonChanged = (model) => {
        if (this.initInProgess == false) {
            if (model != null) {
                this.AffectedPersonStateName(model.StateName);
                this.OwnerPersonName(model.SupervisorPersonFullName);
                this.OwnerPersonId(model.SupervisorPersonId);
                this.FromDateJs("");
                this.ToDateJs("");
                this.HolidayDays(0);
            }
            else {
                this.AffectedPersonStateName("");
                this.OwnerPersonName("");
                this.OwnerPersonId(null);
                this.FromDateJs("");
                this.ToDateJs("");
                this.HolidayDays(0);
            }
            this.IsApprovalAllowed();
        }
    };

    CalculateHolidayDays() {
        if (this.initInProgess == false) {
            if (this.FromDateJs() != null && this.FromDateJs() != "" && this.ToDateJs() != null && this.ToDateJs() != "") {
                Bao.post("Holiday/GetHolidayDays", JSON.stringify({
                    FromDay: this.FromDateJs(),
                    ToDay: this.ToDateJs(),
                    PersonId: this.AffectedPersonId()
                }), (value) => {
                    this.HolidayDaysJs(0);
                    this.HolidayDaysJs(value);
                });
            }
        }
    }

    CompleteCheck() {
        let isComplete = true;

        if (this.AffectedPersonId() == null) {
            isComplete = false;
        }
        if (this.HolidayTypeAsString() == "1" || this.HolidayTypeAsString() == "2") {
            let tmpState_ignoreSubscribes = this.ignoreSubscribes;
            this.ignoreSubscribes = true;
            this.ToDateJs(this.FromDateJs());
            this.ignoreSubscribes = tmpState_ignoreSubscribes;
        }
        if (this.HolidayTypeAsString() == "0") {
            if (this.FromDateJs() == null || this.FromDateJs() == "" || this.ToDateJs() == null || this.ToDateJs() == "") {
                isComplete = false;
            }
            else {
                if (this.FromDateJs() > this.ToDateJs()) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidayDateNotValid"), "info");
                    return false;
                }
            }
        }
        if (this.HolidayTypeAsString() == "2") {
            if (Bao.Utils.String.IsNullOrWhitespace("" + this.HolidayDaysJs())) {
                isComplete = false;
            }
            else {
                var x = parseInt(this.HolidayDaysJs());
                if (isNaN(x) || x <= 0) {
                    isComplete = false;
                }
            }
        }
        if (this.FromDateJs() == "") {
            isComplete = false;
        }
        if (!this.HolidayHideIsSubstituteClarified()) {
            if (this.IsSubstituteClarified() == null || this.IsSubstituteClarified() == false) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidaySubstituteNotClarified"), "info");
                return false;
            }
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return false;
        }
        return this.CheckConflictsWithOtherHolidayRequests();
    }
    
    /**
     * returns true, if everything is okay, false if conflicts found.
     * Shows a Message, if conflicts found and a message was returned from server
     */
    CheckConflictsWithOtherHolidayRequests() {
        return Bao.post("Holiday/HasHolidayRequestConflicts", JSON.stringify({ model: this.MinimizeEntity() }))
            .then((serverResult: {
            Result: boolean;
            Message: string;
        }) => {
            if (serverResult.Result && !Bao.Utils.String.IsNullOrEmpty(serverResult.Message)) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, serverResult.Message, "info");
            }
            return !serverResult.Result;
        });
    }
    
    IsApprovalAllowed() {
        return Bao.post("Holiday/IsApprovalAllowed", JSON.stringify({
            requesterPersonId: ko.map.toJS(this.AffectedPersonId()),
            ticketTypeId: ko.map.toJS(this.TicketTypeId())
        }), (result) => {
            this.ApprovalAllowed(result);
        });
    }

    /**
     * Get TicketTypeCategoryId for selected TicketTypeId and set IsPersonalDepartmentSuperior()
     */
    GetTicketTypeCategory() {
        return Bao.post("Holiday/GetTicketTypeCategory", JSON.stringify({
            ticketTypeId: ko.map.toJS(this.TicketTypeId())
        }), (result) => {
            this.IsPersonalDepartmentSuperior(result === TicketTypeCategoriesConstants.HOLIDAY_REQUEST);            
        });
    }
    
    Approve() {
        $.when(this.CompleteCheck()).then((completeResult) => {
            if (completeResult != true) {
                return;
            }
            var approveDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidayApproveQuestion"));
            approveDialog.Width("600px");
            approveDialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgApprove"),
                    Click: () => {
                        approveDialog.DialogResult(true);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgReject"),
                    Click: () => {
                        approveDialog.DialogResult(false);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: () => {
                        approveDialog.DialogResult(null);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(true),
                    Focus: () => { }
                }
            ]);

            this.subscribe(approveDialog.DialogResult, (approveResult) => {
                if (approveResult === true || approveResult === false) {
                    this.Save().then(() => {
                        var approveStateId = this.TicketStateIdApproved();
                        if (approveResult == false) {
                            approveStateId = this.TicketStateIdDeclined();
                        }
                        this.SetApprove(approveStateId);
                    });
                }
            });
            approveDialog.Open();
        });
    }
    
    SetApprove(approveStateId) {
        this.TabPage.IsLoading(true);
        Bao.post("Holiday/Approve", JSON.stringify({
            id: this.TicketId(),
            approveStateId: approveStateId
        }), (result) => {
            if (result == true) {
                BaoMenu.permissionEnable({ ActionKey: "ActionHolidayApprove", Enabled: false, Context: this.TabPage.Context() });
                this.PerformRefresh();
            }
        });
    }
    
    ReopenHoliday() {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgReopenHolidayQuestion"), "question");
        questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                Bao.post("Holiday/ReopenTicket", JSON.stringify({ ticketId: this.TicketId() }), (reopenResult) => {
                    if (reopenResult.Result == true) {
                        this.PerformRefresh();
                    }
                });
            }
        });
    }
    
    TicketUnlock() {
        var q = $.Deferred();
        if (this.TicketId() != null) {
            return Bao.post("Ticket/UnlockTicket", JSON.stringify({ id: this.TicketId(), lockGuid: this.LockGuid() }));
        }
        else {
            q.resolve();
        }
        return q.promise();
    }
    
    BeforeClose(fn: any) {
        if (this.TabPage.IsDirty() == true && this.SaveAllowed() === true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._saveMessage, "question");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    $.when(this.CompleteCheck()).then((completeResult) => {
                        this.TabPage.IsLoading(true);
                        if (completeResult == true) {
                            $.when(this.Save()).done(() => {
                                $.when(this.TicketUnlock()).then(() => {
                                    this.TabPage.IsLoading(false);
                                    this.DestroyObject();
                                    fn();
                                });
                            });
                        }
                    });
                }
                else if (result === false) {
                    this.TabPage.IsLoading(true);
                    $.when(this.TicketUnlock()).then(() => {
                        this.TabPage.IsLoading(false);
                        this.DestroyObject();
                        fn();
                    });
                }
            });
        }
        else {
            this.TicketUnlock();
            this.DestroyObject();
            fn();
        }
    }
    
    BeforeRefresh() {
        if (this.TabPage.IsDirty() && (this.SaveAllowed == null || this.SaveAllowed())) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._saveMessage, "question");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    $.when(this.CompleteCheck()).then((completeResult) => {
                        if (completeResult == true) {
                            this.Save().done(() => {
                                this.PerformRefresh();
                            });
                        }
                    });
                }
                else if (result === false) {
                    this.PerformRefresh();
                    ;
                }
            });
        }
        else {
            this.PerformRefresh();
        }
    }
    
    BeforeDelete = () => {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                this.Delete();
            }
        });
    }

    PerformRefresh() {
        this.TabPage.IsLoading(true);
        Bao.post("Holiday/Get", JSON.stringify({ id: this.TicketId() })).then((result) => {
            this.TabPage.ObjectId(result.TicketId);
            ko.map.fromJS(result, this);
            this.TabPage.DirtyFlag.reset();
            this.SetPermissons();
            this.TabPage.IsLoading(false);
        });
    }
    
    MinimizeEntity() {
        var model = ko.map.toJS(this);
        delete model.HolidayDays;
        return model;
    }
    
    /**
     * If page is initialized with personid, set the models-personid and get personname
     */
    InitParamPersonId() {
        if (this.initialPersonId !== null) {
            this.AffectedPersonId(this.initialPersonId);
            return Bao.post("ConfigurationItem/GetPersonByUserId", JSON.stringify({
                userId: ko.unwrap(this.AffectedPersonId)
            })).done((result) => {
                if (result?.FullName) {
                    this.AffectedPersonName(result?.FullName);
                }
            })
        }
        else if (this.prefill) {
            return Bao.post("ConfigurationItem/GetPersonByUserId", JSON.stringify({
                userId: ko.unwrap(Bao.Session.User.UserId)
            })).done((result) => {
                if (result?.ConfigurationItemId && result?.FullName) {
                    this.AffectedPersonId(result?.ConfigurationItemId);
                    this.AffectedPersonName(result?.FullName);
                }
            })
        }
    }

    /**
     * If page is initialized with personid, set the models-personid and get personname
     */
    InitParamDate() {
        if (this.initialDate !== null) {
            //this.FromDateJs(moment(date).format(Bao.Utils.DateTimeFormat));
            this.FromDateJs(this.initialDate);
        }
    }

    InitUrlParams() {
        return $.when(this.InitParamPersonId(), this.InitParamDate());
    }

    init() {
        this.initialPersonId = BaoRouter.getRouteValue("PersonId", this.TabPage);
        this.initialDate = BaoRouter.getRouteValue("Date", this.TabPage);
        this.prefill = BaoRouter.getRouteValue("prefill", this.TabPage);
        return super.init()
            .then(() => { return this.loadMetaData() })
            .then(() => { return this.InitUrlParams(); });
    }

    loaded = function () {        
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        this.SetPermissons();
        this.initInProgess = false;
    }

    loadMetaData() {
        return Bao.post("Holiday/GetConstantValues", (value) => {
            if (value != null) {
                this.HolidayHideIsSubstituteClarified(value.holidayHideIsSubstituteClarified);
                this.TicketStateIdApproved(value.ticketApproveStateApproved);
                this.TicketStateIdDeclined(value.ticketApproveStateDeclined);
                this.TicketStateIdInDecision(value.ticketApproveStateInDecision);
                this.TicketStatusClosed(value.ticketApproveStateClosed);
                this.TicketStatusWaitsForApproval(value.ticketApproveStateWaitForApproval);
            }
        });
    }

    PrimaryKey = "TicketId";
    RefreshUrl = "Holiday/Get";
    SaveUrl = "Holiday/Save";
    DeleteUrl = "Holiday/Delete";
    IsInUseUrl = "Holiday/IsInUse";
    PermissionForward = "HolidayMoveForwardSearch";
    PermissionBackward = "HolidayMoveBackwardSearch";
    PermissionSave = "HolidaySave";
    PermissionRefresh = "HolidayRefresh";
    PermissionDelete = "HolidayDelete";


    //#region Protected Methods

    /**
      * Sets permissions
      */
    protected SetPermissons() {
        BaoMenu.permissionEnable({ ActionKey: "HolidayDelete", Enabled: !this.IsReadonly(), Context: this.TabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: "HolidaySave", Enabled: !this.IsReadonly(), Context: this.TabPage.Context() });
        BaoMenu.permissionEnable({
            ActionKey: "ActionHolidayApprove",
            Enabled: !this.IsReadonly() && this.ApprovalAllowed() && (this.TicketApproveStateId() == null || this.TicketApproveStateId() == this.TicketStateIdInDecision()),
            Context: this.TabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "ActionHolidayReOpen",
            Enabled: this.TicketStatusId() == this.TicketStatusClosed() && !this.TicketLocked(),
            Context: this.TabPage.Context()
        });
    }

    //#endregion
}
export default HolidayViewModel;